import { useTranslation } from 'react-i18next';

import styles from './index.module.css';

interface Props {
  currentLength: number;
  limit: number;
}

const CharacterLimit: React.FC<Props> = ({ currentLength, limit }) => {
  const { t } = useTranslation();
  return (
    <span className={styles.CharacterLimit}>
      {currentLength}/{limit} {t('characters')}
    </span>
  );
};

export default CharacterLimit;
